module.exports = __webpack_public_path__ + "img/22.e326bee3.jpg";